import { useMemo } from 'react'

import { ISortSelectOption } from 'src/components/filter/types/filter.types'
import { defaultSelect } from 'src/constants'

const useSusepnedListSelectionOptions = () => {
  const data = ['is suspended', 'is not suspended']

  const items = useMemo(() => {
    const selectionValues: ISortSelectOption[] = data
      ? data.map((el) => ({
          label: el,
          value: el,
        }))
      : []

    selectionValues.unshift(defaultSelect)

    return selectionValues
  }, [data])

  return { selectName: 'accounts-suspended-button-text.v', queryParamName: 'suspended', items }
}

export { useSusepnedListSelectionOptions }
